export enum AppSubdomain {
    accounts = 'account-settings',
    devCenter = 'devcenter',
    earn = 'earn',
    profiles = 'profiles',
    tcAcademy = 'academy',
    onboarding = 'onboarding',
    work = 'work',
    talentSearch = 'talent-search',
    wallet = 'wallet',
    walletAdmin = 'wallet-admin',
    copilots = 'copilots',
    admin = 'system-admin',
    review = 'review',
    calendar = 'calendar',
    engagements = 'engagements',
    customer = 'customer',
    reports = 'reports'
}

export enum ToolTitle {
    accounts = 'Account Settings',
    devCenter = 'Dev Center',
    earn = 'Opportunity Feed',
    profiles = 'Profiles',
    tcAcademy = 'Topcoder Academy',
    selfService = 'Self Service Challenges',
    onboarding = ' ',
    talentSearch = 'Expert Talent',
    wallet = 'Wallet',
    walletAdmin = 'Wallet Admin',
    copilots = 'Copilots',
    admin = 'Admin',
    review = 'Review',
    calendar = 'Calendar',
    engagements = 'Engagements',
    customer = 'Customer',
    reports = 'Reports'
}

export const PageSubheaderPortalId: string = 'page-subheader-portal-el'
